import {Observable, Scheduler, Subscriber} from "rxjs";
import {AppUtil} from "../../js/util/AppUtil";

export class SseSource {

    public static create<T>(url: string): Observable<T> {
        return Observable.create((subscriber: Subscriber<T>) => {

            const reConnect = AppUtil.debounce(() => connect(), 45000);

            let source: EventSource | null = null;

            const connect = () => {
                if (subscriber.closed) {
                    return;
                }

                source?.close();

                reConnect();

                source = new EventSource(url, {withCredentials: true});

                source.onmessage = (evt) => {
                    reConnect();

                    if (subscriber.closed) {
                        source?.close();
                    } else {
                        try {
                            const data = JSON.parse(evt.data);
                            console.debug("Event from server", data.type);
                            subscriber.next(data);
                        } catch (e) {
                            console.error(e);
                        }
                    }
                };

                source.onerror = () => reConnect();

                // Close the source on unsubscribe
                subscriber.add(() => source?.close());
            };

            connect();
        }).observeOn(Scheduler.async);
    }

    public static isAvailable(): boolean {
        return "EventSource" in window;
    }
}
